import { CheckoutRawModel } from '@/api/api-raw-models/checkout-raw-model';
import { CheckoutModel } from '@/models/CheckoutModel';

export const mapCheckout = (e: CheckoutRawModel): CheckoutModel => ({
  orderId: e.order_id,
  paid: e.paid,
  userRewardsInfo: e.user_rewards_info,
});
